'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var template = require('modules/settings/templates/layout/subscription/modal.hbs');

var SubscriptionModalLayout = LayoutView.extend({
    template: template,

    ui: {
        title: '.subscription-modal-title',
        actionCancel: '[data-action="cancel"]',
        actionSave: '[data-action="save"]',
    },

    events: {
        'click @ui.actionCancel': 'actionCancel',
        'click @ui.actionSave': 'actionSave',
    },

    childEvents: {
        'readyToSave': 'enableSaveButton',
        'revokeReadyToSave': 'disableSaveButton',
        'saved': 'actionClose',
        'saving': 'showSaveButtonLoader',
        'save:error': 'handleSaveError',
    },

    regions: {
        bodyRegion: '.modal-body section',
    },

    title: '',

    onShow: function() {
        this.ui.title.text(this.getOption('title'));

        this.bodyRegion.show(this.options.bodyView);
    },

    actionCancel: function(event) {
        this.trigger('close:modal');
    },

    actionClose: function(event) {
        this.trigger('close:modal');
    },

    actionSave: function(event) {
        //trigger submit in child view
        this.options.bodyView.triggerMethod('submit');
    },

    /**
     * Shows loader on the save button
     */
    showSaveButtonLoader: function() {
        this.ui.actionSave.prop('disabled', true).addClass('is-loading');
    },

    /**
     * Enables the save button
     */
    enableSaveButton: function(view, data) {
        this.ui.actionSave.prop('disabled', false);

        var hasToPay = !!(data && data.hasToPay);
        var saveButtonLabel = data && data.saveButtonLabel ? data.saveButtonLabel : App.t('subscription::setup:save:button');
        this.ui.actionSave.html(saveButtonLabel).toggleClass('is-pay', hasToPay);
    },

    /**
     * Disables the save button
     */
    disableSaveButton: function(view, data) {
        this.ui.actionSave.prop('disabled', true);

        var hasToPay = !!(data && data.hasToPay);
        var saveButtonLabel = data && data.saveButtonLabel ? data.saveButtonLabel : App.t('subscription::setup:save:button');
        this.ui.actionSave.html(saveButtonLabel).toggleClass('is-pay', hasToPay);
    },

    /**
     * Handles the error in a subview
     * @param {object}  childView The childview that triggered the error
     * @param {object} response  (Optional) The error response
     */
    handleSaveError: function(childView, response) {
        this.ui.actionSave.prop('disabled', false).removeClass('is-loading');
        var errorObject = response && response.responseJSON && response.responseJSON.error;
        if (!errorObject) {
            var message = Messenger().error({
                message: App.t('subscription::setup:message:error-checkout-process'),
                actions: {
                    try: {
                        label: App.t('subscription::setup:button:try-again'),
                        action: function() {
                            this.actionSave();
                            message.hide();
                        }.bind(this),
                    },
                },
            });
        }
    },
});

module.exports = SubscriptionModalLayout;